import { allow } from '../classes/allow';

export default function getDomElementProps(originalProps = {}) {
    allow.anObject(originalProps);
    let domElementProps = {};
    Object.keys(originalProps).forEach(propName => {
        if (propName === 'children' || propName.includes('margin') || propName.includes('padding') || propName === 'cols' || propName === 'float')
            return;
        if (propName === propName.toLowerCase())
            domElementProps[propName] = originalProps[propName];
    });
    return domElementProps;
}